import React from 'react';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import ValidationText from '../../../utils/validation/ValidationText.js';

const ItemForm1 = (props) => {
    return (
        <div className="item-form">
            <div className="item-grp flex gap-2.5 mb-4">
                <div className="input-grp w-[15%]">
                    <label>Invoice No.</label>
                    <input
                        type="text"
                        id="invoiceNo"
                        name="invoiceNo"
                        className="inputFocus w-full"
                        disabled
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceNo}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceNo", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[15%]">
                    <label>Invoice Date</label>
                    <input
                        type="date"
                        id="invoiceDate"
                        name="invoiceDate"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceDate}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceDate", "invoiceDetails")
                        }
                    />

                </div>

                <div className="input-grp w-[10%]">
                    <label>Credit Days</label>
                    <input
                        type="number"
                        id="creditDay"
                        name="creditDay"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.creditDay}
                        onChange={(event) =>
                            props.handleChange(
                                event,
                                "creditDay",
                                "invoiceDetails"
                            )
                        }
                    />
                </div>

                <div className="input-grp w-[15%]">
                    <label>Order No</label>
                    <input
                        type="text"
                        id="orderNo"
                        name="orderNo"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.orderNo}
                        onChange={(event) =>
                            props.handleChange(event, "orderNo", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[25%]">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                        drpIdentity="partyId"
                        options={props.partyDropdownList}
                        className={` ${props.validStateForPartyDetails?.error?.partyId ? "errorInput" : ""}`}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParameters(selected, "partyId")
                        }
                        allowSelectAll={false}
                        value={props.partyDropdownList.filter(
                            (party) =>
                                party.value === props.invoiceDetails.partyId
                        )}
                    />
                    {/* <ValidationText error={props.validStateForPartyDetails.error.partyId} /> */}
                </div>

                <div className="input-grp w-[20%]">
                    <label>Transport Name</label>
                    <MultiSelectDropdown
                        drpIdentity="transportName"
                        options={props.transportCourierList}
                        className={` ${props.validStateForPartyDetails?.error?.transportId ? "errorInput" : ""}`}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParameters(selected, "transportName")
                        }
                        allowSelectAll={false}
                        value={props.transportCourierList.filter(
                            (transport) =>
                                transport.value === props.invoiceDetails.transportId
                        )}
                    />
                    {/* <ValidationText error={props.validStateForPartyDetails.error.transportId} /> */}
                </div>
            </div>
        </div>
    );
};

export default ItemForm1;